export default __webpack_public_path__ + "static/media/imgLiquidosOrganicos.bbc085e9.png";